<template>
    <el-drawer
        :title="formData.id ? '编辑票品' : '新增票品' "
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
        append-to-body
		
    >
        <div class="drawer-content">
            <el-form v-if="!formData.id && form1.step == 1" :model="form1" ref="form1" label-position="top" size="medium">
                <el-form-item prop="modle" label="请选择票品的类型:">
                    <el-radio-group v-model="form1.modle">
                        <div><el-radio :label="1">{{type == 0 ? "普通门票" : "通票"}}-单人票，只能一个人入场</el-radio></div>
                        <div class="MT20"><el-radio :label="2">{{type == 0 ? "普通门票" : "通票"}}-多人票，适用于多人票，比如情侣票，一张票允许两个人入场，用户票夹会得到两个入场码</el-radio></div>
                        <template v-if="type == 0">
                            <div class="MT20"><el-radio :label="3">乘车票-单人票</el-radio></div>
                            <div class="MT20"><el-radio :label="4">乘车票-多人票</el-radio></div>
                            <div class="MT20"><el-radio :label="5">权益票-单人票</el-radio></div>
                        </template>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <el-form
                v-if="formData.id || form1.step == 2"
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
            >
                <el-row :gutter="20">
                    <el-col v-if="type ==  0" :xs="24" :md="12">
                        <el-form-item prop="groupId" label="票品类型:">
                            <!-- 编辑状态下票品类型不可更改，仅新增时可选择 -->
                            <el-select v-model="formData.groupId" size="medium" :disabled="!!formData.id">
                                <el-option :value="1" label="普通门票"></el-option>
                                <el-option :value="2" label="车票"></el-option>
                                <el-option :value="3" label="权益票"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="ticketName" label="票品名称:">
                            <el-input
                                v-model="formData.ticketName"
                                placeholder="请填写票品名称"
                                :maxlength="20"
                                size="medium"
                                :disabled="type == 1 && formData.isSeat == 1 ? true : false"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="formData.memberNum > 1 || form1.modle == 2 || form1.modle == 4" :xs="24" :md="12">
                        <el-form-item prop="memberNum" class="has-tips">
                            <template slot="label">
                                <span>可入场人数: </span>
                                <div class="tips">
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content">适用于多人票，比如双人票，一张票允许两个人入场，用户票夹会得到两个入场码</div>
                                        <span>适用于多人票，比如双人票，一张票允许两个人入场，用户票夹会得到两个入场码<div class="color-danger">如果演出是预售中或已产生过订单，不可修改</div></span>
                                    </el-tooltip>
                                </div>
                            </template>
                            <el-input-number v-model="formData.memberNum" size="medium" :disabled="formData.id && !formData.canUpdateMemberNum" :min="2" :max="50" :precision="0" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="status" label="销售状态:">
                            <el-select v-model="formData.status" size="medium" @change="formData.couponCode = '';$refs.formData.clearValidate('couponCode')">
                                <el-option :value="0" label="正常销售"></el-option>
                                <el-option :value="1" label="暂停销售">暂停销售<span class="color-info">（隐藏票品，不展示给用户）</span></el-option>
                                <el-option :value="2" label="优惠码销售"></el-option>
                                <el-option :value="3" label="白名单销售"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="formData.status == 2" :xs="24" :md="12"> 
                        <el-form-item prop="couponCode" :rules="[{ required: true, message: '请填写优惠码' }]">
                            <span slot="label">优惠码: <small><span class="el-icon-info"></span>填写了优惠码后，用户才能看到并购买该票品</small></span>
                            <el-input
                                v-model="formData.couponCode"
                                placeholder="请填写优惠码"
                                :maxlength="20"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col v-if="formData.status == 3" :xs="24" :md="12"> 
                        <el-form-item prop="couponCode" :rules="[{ required: true, message: '请填写白名单用户ID' }]">
                            <span slot="label">白名单用户ID: <small><span class="el-icon-info"></span>多个用户ID之间用英文逗号分隔</small></span>
                            <el-input
                                v-model="formData.couponCode"
                                placeholder="请填写白名单用户ID"
                                :maxlength="5000"
                                size="medium"
                                show-limit-word
                            ></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="datetimerange1">
							<span slot="label">
							    销售时间：
							    <el-checkbox v-model="formData.isAsyncAlterConsignTime" :true-label="1"
							    		:false-label="0" class="ML20">勾选后同步修改候补、托售结束时间</el-checkbox>
							</span>
                            <el-date-picker
                                v-model="formData.datetimerange1"
                                type="datetimerange"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                size="medium"
                                unlink-panels
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="isHideStartDate" label="是否展示销售时间段:">
                            <el-select v-model="formData.isHideStartDate" size="medium">
                                <el-option :value="0" label="是"></el-option>
                                <el-option :value="1" label="否"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :xs="24" :md="12"> 
                        <el-form-item prop="datetimerange2" label="验票有效期:">
                            <el-date-picker
                                v-model="formData.datetimerange2"
                                type="datetimerange"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                size="medium"
                                unlink-panels
                            ></el-date-picker>
                        </el-form-item>
                    </el-col> -->

                    <!-- 场次票品绑定场次 -->
                    <el-col v-if="type ==  0 && !formData.id" :xs="24" :md="12">
                        <el-form-item prop="sessionVo" label="绑定场次:">
                            <el-select
                                v-model="formData.sessionVo"
                                filterable
                                placeholder="请输入场次"
                                size="medium"
                                value-key="id">
                                <el-option
                                    v-for="item in sessionList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- 权益票绑定前置票 -->
                    <el-col v-if="formData.groupId == 3" :xs="24" :md="12">
                        <el-form-item prop="mainPriceId" label="绑定前置票:">
                            <el-select
                                v-model="formData.mainPriceId"
                                filterable
                                placeholder="请选择前置票"
                                size="medium">
                                <el-option
                                    v-for="item in mainPriceList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- 通票设置绑定场次 -->
                    <template v-if="type == 1">
                        <el-col :xs="24" :md="12">
                            <el-form-item prop="sessionIds" label="绑定验票场次:">
                                <el-select 
                                    v-model="formData.sessionIds" 
                                    multiple
                                    filterable
                                    placeholder="请输入验票场次"
                                    size="medium"
                                    value-key="id"
                                    :disabled="formData.isSeat == 1 ? true : false">
                                    <el-option
                                        v-for="item in sessionList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :xs="24" :md="12">
                            <el-form-item prop="canBuySessions" label="绑定展示场次:">
                                <el-select 
                                    v-model="formData.canBuySessions" 
                                    multiple
                                    filterable
                                    placeholder="请输入展示场次"
                                    size="medium"
                                    value-key="id">
                                    <el-option
                                        v-for="item in sessionList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
                    </template>


                    <!-- <el-col :xs="24" :md="12"> 
                        <el-form-item prop="lock" label="二维码加锁:">
                            <el-radio-group v-model="formData.lock" size="medium">
                                <el-radio :label="1">已加锁</el-radio>
                                <el-radio :label="0">不加锁</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col> -->
                    <!-- <el-col v-if="formData.lock == 1" :xs="24" :md="12"> 
                        <el-form-item prop="ticketQrCodeShowTime">
                            <span slot="label">解锁时间: <small><span class="el-icon-info"></span>解锁后，用户才可以看到二维码</small></span>
                            <el-date-picker
                                v-model="formData.ticketQrCodeShowTime"
                                type="datetime"
                                placeholder="选择时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                size="medium"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col> -->
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="sellPrice">
							<span slot="label">
							    票品售价：
							    <el-checkbox v-model="formData.isUndetermined" :true-label="1" :false-label="0">是否价格待定 </el-checkbox>
							</span>
                            <el-input-number style="width:100%" v-model="formData.sellPrice" :precision="2" controls-position="right" :min="0.00" :max="99999999.99" size="medium" placeholder="请填写票品售价"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="originalPrice" label="票品原价:">
                            <el-input-number style="width:100%" v-model="formData.originalPrice" :precision="2" controls-position="right" :min="0.00" :max="99999999.99" size="medium" placeholder="请填写票品原价"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="accountLimitNum" >
                            <span slot="label">票品账号限购: <small>对当前票品限制最多允许购买的票数,0为不限购</small></span>
                            <el-input-number style="width:100%" v-model="formData.accountLimitNum" :precision="0" controls-position="right" :min="0" :max="99999999" size="medium" placeholder="请填写票品限购"></el-input-number>
                        </el-form-item>
                    </el-col>
                   <!-- <el-col :xs="24" :md="12"> 
                        <el-form-item prop="certificateLimitNum" >
                            <span slot="label">票品证件号限购: <small>对当前票品限制最多允许购买的票数,0为不限购</small></span>
                            <el-input-number style="width:100%" v-model="formData.certificateLimitNum" :precision="0" controls-position="right" :min="0" :max="99999999" size="medium" placeholder="请填写票品限购"></el-input-number>
                        </el-form-item>
                    </el-col>-->
                    <el-col v-if="!formData.id && (isSeat != 1 || isSeat == 1 && formData.groupId == 2)" :xs="24" :md="12"> 
                        <el-form-item prop="totalNum" label="库存:">
                            <el-input-number style="width:100%" v-model="formData.totalNum" :precision="0" controls-position="right" :min="1" :max="99999999" size="medium" placeholder="请填写库存"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12">
                        <el-form-item prop="transformFlag" label="核销后再次出入场:">
                            <el-radio-group size="medium" v-model="formData.transformFlag">
                                <el-radio :label="0">关闭：门票核销后立即作废</el-radio>
                                <el-radio :label="1" class="MT10">开启：门票核销后暂不作废，支持出场后换绑观演人再次入场</el-radio>
                                <el-radio :label="-1" class="MT10">开启：门票核销后暂不作废，支持自己多次出入场（不能换绑观演人）</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="formData.transformFlag == 1" :xs="24" :md="12"> 
                        <el-form-item prop="transformNum" >
                            <span slot="label">
                                换绑次数: 
                                <small>
                                    <el-popover width="400">
                                        <small>
                                            <div>表示出场后还有换绑观演人的次数</div>
                                            <div class="MT10 color-danger">注意：同一时刻只允许票品当前观演人入场</div>
											<div class="MT10">次数用完以后，可以出场，但是不能再绑定</div>
                                        </small>
                                        <el-link slot="reference" type="info" :underline="false" style="vertical-align: baseline;">1-100<span class="el-icon-question"></span></el-link>
                                    </el-popover>
                                </small>
                            </span>
                            <el-input-number style="width:100%" v-model="formData.transformNum" :precision="0" controls-position="right" :min="1" :max="100" size="medium" placeholder="请填写支持转赠次数"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
				<el-form-item prop="isSoldOut" label="强制售罄:" :class="{'M0': type == 1}">
				    <el-checkbox v-model="formData.isSoldOut" :true-label="1" :false-label="0">开启强制售罄，开启后即使有剩余库存，也禁止用户下单、候补订单也会停止匹配 </el-checkbox>
				</el-form-item>
                <el-form-item prop="isTicketExtendSession" label="票品形态:" :class="{'M0': type == 1}">
                    <!-- <el-select v-if="type == 0" v-model="formData.isTicketExtendSession" size="medium">
                        <el-option :value="1" label="沿用场次设置"></el-option>
                        <el-option :value="0" label="其他"></el-option>
                    </el-select> -->
					<ticket-type :formData.sync="formData" :channelName.sync="channelName"></ticket-type>
                </el-form-item>
                <el-form-item prop="isPerformerExtendSession" label="票品绑定观演人:" :class="{'M0': type == 1}">
                    <!-- <el-select v-if="type == 0" v-model="formData.isPerformerExtendSession" size="medium">
                        <el-option :value="1" label="沿用场次设置"></el-option>
                        <el-option :value="0" label="其他"></el-option>
                    </el-select> -->
					<real-name  :formData.sync="formData" :channelName.sync="channelName"></real-name>
                </el-form-item>
                <!-- 权益票隐藏下单人实名认证 -->
                <el-form-item v-if="formData.groupId != 3" prop="isRealNameExtendSession" label="下单人实名认证:" :class="{'M0': type == 1}">
                    <!-- <el-select v-if="type == 0" v-model="formData.isRealNameExtendSession" size="medium">
                        <el-option :value="1" label="沿用场次设置"></el-option>
                        <el-option :value="0" label="其他"></el-option>
                    </el-select> -->
					<real-name-buyer  :formData.sync="formData" :channelName.sync="channelName"></real-name-buyer>
                </el-form-item>
                <!-- 权益票显示"权益说明"，其他票品显示"票品说明" -->
                <el-form-item prop="instruction" :label="formData.groupId == 3 ? '权益说明:' : '票品说明:'">
                    <el-input
                        v-model="formData.instruction"
                        :placeholder="formData.groupId == 3 ? '请填写权益说明' : '请填写票品说明'"
                        type="textarea"
                        size="medium"
                        maxlength="100"
                        :autosize="{minRows:2}"
                        show-word-limit
                    ></el-input>
                </el-form-item>                
                <el-form-item v-if="formData.id" prop="validateType">
                    <span slot="label">防黄牛刷票验证: <small>Token验证是一种技术上的防黄牛刷票机制, 对重点演出防黄牛有奇效, 正常用户下单全程无感知, 暂时只能技术人员开启, 需要开启请联系成都技术人员。<span class="color-danger">开启防黄牛刷票验证后，票品将不会推给外部销售渠道。</span></small></span>
                    <el-checkbox-group v-model="validateName" size="medium">
                        <!-- <el-checkbox :label="2">开启腾讯云验证</el-checkbox> -->
                        <el-checkbox :label="3" :disabled="formData.canUpdateValidateType == 0">开启Token验证</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <!-- 开启定时购白名单（仅已配置定时购任务的票品支持设置，需求 7121828104） -->
                <el-form-item v-if="formData.id && supportWhitelistSetting">
                    <span slot="label">定时购白名单: <small>开启后仅手机号在白名单内的用户订单参与定时购抽签，白名单在票品列表的「定时购白名单」按钮中导入</small></span>
                    <el-checkbox-group v-model="whitelistChecked" size="medium">
                        <el-checkbox :label="1">开启定时购白名单</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button v-if="!formData.id && form1.step == 1" type="primary" @click="form1.step = 2">下一步</el-button>
            <el-button v-if="formData.id || form1.step == 2" type="primary" @click="submitForm()" :loading="btnLoading" >确 定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import TicketType from './ticket-type';
import RealName from './real-name';
import RealNameBuyer from './real-name-buyer';
const defaultFormData = {
    ticketName:'',
    status:0,
    datetimerange1:[],
    startTime: "",
    endTime: "",
    datetimerange2:[],
    validStartTime:'',
    validEndTime:'',
    couponCode:'',
    isHideStartDate:0,
    ticketQrCodeShowTime:'',
    lock:0,
    sellPrice:'',
    originalPrice:'',
    accountLimitNum:0,
    //certificateLimitNum:0,
    totalNum:'',
    instruction:'',
    // canBuySessions:[],
    // canCheckSessions:[],
    sessionIds:[],
    sessionVo: null,
    validateType: 0,
    groupId:1,
    mainPriceId: null,//权益票绑定的前置票id


   // isTicketExtendSession: 0, //没有沿用场次设置这个功能了
    ticketType: 1,
    pickupTimes:[],
    pickupAddress:'',
    pickupLongitude: '',
    pickupLatitude:'',
    pickupInstruction:'上门自取时,请提供二维码,手机号,身份证原件(如代领还需代领人身份证原件)',
    mailInstruction:'免邮/采用到付收费',

   // isPerformerExtendSession: 0, //没有沿用场次设置这个功能了
    realName: 0,
    buyType: 3,
    commonPerformerDocumentType:1,
    //isRealNameExtendSession: 0, //没有沿用场次设置这个功能了
    realNameValidType:1,

    memberNum: 1,

    transformFlag: 0,
    transformNum: 0,
	isSoldOut:0,
	entranceType:[],//5.5.10新增
	ticketStyle:1,//5.5.10新增
	isAsyncAlterConsignTime:0
}
export default {
    props:{
        activityId:{
            type:[Number,String],
            default:''
        },
        type:{
            type: Number,
            default:0 //0、场次票品 1、通票票品
        },
        isSeat: {
            type:[Number,String],
            default: 0
        },
		ticketStyle:{
			type:[Number,String],
			default: 1
		}
    },
    components:{
        TicketType,RealName,RealNameBuyer
    },
    data(){
        return{
            drawerShow:false,
            btnLoading:false,
            dataLoading:false,
            formData:{...defaultFormData},
            rules:{
                ticketName: [{ required: true, message: "请填写票品名称" }],
                datetimerange1:[{ required: true, message: "请填写销售时间" }],
                datetimerange2:[{ required: true, message: "请填写验票有效时间" }],
                // couponCode:[{ required: true, message: "该项必填" }],
                sellPrice:[{required: true, message: "请填写票品售价"}],
                originalPrice:[{required: true, message: "请填写票品原价"}],
                accountLimitNum:[{required: true, message: "请填写账号限购数量"}],
                //certificateLimitNum:[{required: true, message: "请填写证件号限购数量"}],
                totalNum:[{required: true, message: "请填写票品库存"}],
                ticketQrCodeShowTime:[{ required: true, message: "请填写解锁时间" }],
                sessionVo:[{ required: true, message: "请填写绑定的场次" }],
                mainPriceId: [{ required: true, message: "请选择绑定的前置票" }],
                sessionIds: [{ required: true, message: "请绑定验票场次" }],
                memberNum: [{ required: true, message: "请选择可入场人数" }],
                transformNum: [{ required: true, message: "请填写支持转赠次数" }],
				entranceType: [{ required: true, message: "无纸化入场和取票机取票,必须至少开启一项" }],
            },
            sessionList:[],
            mainPriceList:[],//权益票可绑定的前置票列表
            validateName: [],
            supportWhitelistSetting: false, //该票品是否支持设置定时购白名单开关（已配置定时购任务才支持）
            whitelistChecked: [], //定时购白名单勾选（[1]=开启 []=关闭）
            form1: {
                modle: 1,
                step: 1,
            },
			//activityChannel:'',//5.5.10新增
			channelName:'',//6169176781
        }
    },
    watch:{
        "form1.modle"(v){
            if( v == 1 || v == 2 ){
                this.$set(this.formData,'groupId',1)
            }
            if( v == 3 || v == 4 ){
                this.$set(this.formData,'groupId',2)
            }
            //权益票（单人票）
            if( v == 5 ){
                this.$set(this.formData,'groupId',3)
            }
            //多人票需填写可入场人数
            if(v == 2 || v == 4){
                this.$set(this.formData,'memberNum',"")
            }
        },
        //权益票：选择/回显场次后，加载该场次下可绑定的前置票列表
        "formData.sessionVo"(v){
            if(this.formData.groupId == 3 && v){
                //新增时切换场次后清空已选前置票
                if(!this.formData.id){
                    this.$set(this.formData,'mainPriceId',null)
                }
                this.getMainPriceList(v.id)
            }
        },
        //权益票：编辑状态下切换票品类型为权益票时，按已绑定场次加载前置票列表
        "formData.groupId"(v){
            if(v == 3){
                //权益票不支持「先购票后再绑定」，切换为权益票时修正为「购票时要求绑定」
                if(this.formData.buyType == 3){
                    this.$set(this.formData, 'buyType', 2);
                }
                if(this.formData.sessionVo){
                    this.getMainPriceList(this.formData.sessionVo.id)
                }
            }
        },
        //权益票：选择/更换前置票后，证件绑定时机跟随主票设置
        "formData.mainPriceId"(v){
            if(this.formData.groupId == 3 && v){
                this.syncBenefitBuyType(v);
            }
        }
    },
    created(){
        this.getSession()
    },
    methods:{
        show(channelName,data,sessionVo){
			this.channelName = !channelName ? 'showstart' : channelName.toString()
			//this.channelName = channelName ? channelName : ''
            this.formData = data ? {
                ...defaultFormData,
                ...data,
                lock:data.ticketQrCodeShowTime ? 1 : 0,
                datetimerange1:data.startTime ? [data.startTime,data.endTime] : [],
                datetimerange2:data.validStartTime ? [data.validStartTime,data.validEndTime] : [],
                sessionVo:sessionVo || null,
                transformFlag: data.transformNum > 0 ? 1 : data.transformNum,
				buyType:data.realName == 0 ? 0 : data.buyType,
				entranceType:data.entranceType ? data.entranceType.split(',').map(v => parseInt(v)) : [],
				ticketType:data.electronicType == 1 && data.TicketType == 1 ? 1 : data.electronicType == 2 && data.ticketType == 1 ? 5 : data.ticketType,
				ticketStyle:data.ticketType > 1 ? 2 : 1
				
            } : {
                ...defaultFormData,
                // isTicketExtendSession: this.type == 1 ? 0 : 1,
                // isPerformerExtendSession: this.type == 1 ? 0 : 1,
                // isRealNameExtendSession: this.type == 1 ? 0 : 1,
            };

            if(data){
                if( data.validateType == 2 ){
                    this.validateName.push(2);
                }
                if( data.validateType == 3 ){
                    this.validateName.push(3);
                }
                if( data.validateType == 4 ){
                    this.validateName.push(2);
                    this.validateName.push(3);
                }
                //定时购白名单开关回显（仅支持设置的票品显示勾选项）
                this.supportWhitelistSetting = data.supportWhitelistSetting == true;
                this.whitelistChecked = data.supportWhitelistSetting == true && data.isOpenWhitelist == 1 ? [1] : [];
            }

            this.drawerShow = true;
        },
        close(){
            this.formData = {...defaultFormData};
            this.$refs.formData && this.$refs.formData.resetFields();
            this.validateName = [];
            this.supportWhitelistSetting = false;
            this.whitelistChecked = [];
            this.form1 = {
                step:1,
                modle:1
            };
            //重置前置票列表及缓存
            this.mainPriceList = [];
            this._lastMainPriceSessionId = null;
            this.drawerShow = false;
        },
        //搜索场次
        getSession(){
            this.$request({
                url: '/activity/sessionNames',
                params: {activityId:this.activityId},
                method: "post",
            })
                .then((res) => {
                    const { state,result } = res.data;
                    if (state == 1) {
                        this.sessionList = result || [];
                    }
                })
        },
        //获取权益票可绑定的前置票列表
        getMainPriceList(sessionId){
            //同一场次不重复请求
            if(this._lastMainPriceSessionId == sessionId) return;
            this._lastMainPriceSessionId = sessionId;
            this.$request({
                url: '/activity/ticketSelectList',
                params: {
                    activityId: this.activityId,
                    sessionId: sessionId,
                    ticketPriceId: this.formData.id
                },
                method: "post",
            })
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1) {
                        //编辑时排除自身，避免将自己设为前置票
                        this.mainPriceList = (result || []).filter(v => v.id != this.formData.id);
                        //权益票：编辑回显时已绑定前置票，证件绑定时机跟随主票设置
                        if(this.formData.groupId == 3 && this.formData.mainPriceId){
                            this.syncBenefitBuyType(this.formData.mainPriceId);
                        }
                    }
                })
        },
        //权益票：证件绑定时机跟随主票（主票非实名→无须绑定观演人；主票实名→购票时要求绑定）
        syncBenefitBuyType(mainPriceId){
            const _main = (this.mainPriceList || []).find(t => t.id == mainPriceId);
            if(_main){
                //注意：接口返回的 buyType 只有 2/3 无 0 值，须用 realName 判断主票是否实名
                this.$set(this.formData, 'buyType', _main.realName == 1 ? (_main.buyType == 0 ? 0 : 2) : 0);
            }
        },
        //表单提交
        submitForm(){
			
            this.$refs["formData"].validate( async (valid) => {
                if (valid) {                    

                    if(this.formData.lock == 0){
                        this.formData.ticketQrCodeShowTime = '';
                    }
                    if(this.formData.status < 2){
                        this.formData.couponCode = '';
                    }
                    this.formData.startTime = this.formData.datetimerange1[0];
                    this.formData.endTime = this.formData.datetimerange1[1];
                    // this.formData.validStartTime = this.formData.datetimerange2[0];
                    // this.formData.validEndTime = this.formData.datetimerange2[1];					
					
					
					if( this.formData.ticketStyle == 1 &&  (this.formData.ticketType == '' || this.formData.ticketType == 2  || this.formData.ticketType == 3 || this.formData.ticketType == 4 ) ){
						return this.$message.error("请先选择电子票类型！");
					}
					if( this.formData.ticketStyle == 2 &&  ( this.formData.ticketType == '' || this.formData.ticketType == 1  || this.formData.ticketType == 5 ) ){
						return this.$message.error("请先选择纸质票类型！");
					}
					
                    if( new Date( this.formData.startTime.replace(/-/g,"/")).getTime() < new Date().getTime() ){
                        const flag = await this.$confirm('票品的开售时间早于当前时间，这会导致票品立即开售，是否继续提交', '提示', {
                            confirmButtonText: '继续提交',
                            cancelButtonText: '暂不提交',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            center: true,
                            type: 'warning',
                        }).catch(() => 'cancel');

                        if (flag === 'cancel') {
                            return;
                        }
                    }


                    if( this.type == 0 ){
                        this.formData.sessionIds = [{...this.formData.sessionVo}]
                    }

                    //非权益票清空前置票绑定
                    if( this.formData.groupId != 3 ){
                        this.formData.mainPriceId = null;
                    }
					
					if( this.formData.buyType == 0 ){
						this.formData.realName = 0
					}else{
						this.formData.realName = 1
					}
                    this.formData.isThroughTicket = this.type;

                    if( this.validateName.length == 1 ){
                        this.formData.validateType = this.validateName[0];
                    }else if( this.validateName.length > 1 ){
                        this.formData.validateType = 4;
                    }else{
                        this.formData.validateType = this.formData.validateType == 5 ? 5 : 0;
                    }

                    //选座演出 门票库存默认为0
                    if( !this.formData.id && this.isSeat == 1 && this.formData.groupId != 2) {
                        this.formData.totalNum = 0;
                    }

                    //定时购白名单开关：不支持设置的票品不传该字段（后端 null 不更新）
                    this.formData.isOpenWhitelist = this.supportWhitelistSetting ? (this.whitelistChecked.length > 0 ? 1 : 0) : null;

                    this.btnLoading = true;
					//console.log(this.formData)
					//return
					
                    this.$request({
                        url: '/activity/saveTPs',
                        data: {
                            ...this.formData,
                            activityId:this.activityId,
                            transformNum: this.formData.transformFlag > 0 ? this.formData.transformNum : this.formData.transformFlag,
							entranceType:this.formData.entranceType.toString(),
							electronicType:this.formData.ticketType === 5 ? 2 : 1,
							ticketType:this.formData.ticketType === 5 ? 1 : this.formData.ticketType							
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg, result } = res.data;
                            if (state == 1) {
                                this.$emit("onUpdate");
								// window.location.reload()
                                this.close();
                                if(result.content){
                                    this.$confirm('该通票绑定的场次产生了变动。如需告知用户，请到【变动通知】页面进行操作', '提示', {
                                        // type: 'success',
                                        center: true,
                                        confirmButtonText:'查看变动通知',
                                        cancelButtonText:'暂不处理',
                                        closeOnClickModal: false
                                    }).then(() => {
                                        this.$router.push(`/activityManage/activity/edit/changeNotice/${this.activityId}`)
                                    }).catch(() => {
                                        
                                    })
                                }
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
        
    }
}
</script>

<style lang="scss" scoped>
.M0{
    margin: 0;
}
</style>